module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "download-btn-box"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPlatform === 'windows'),
      expression: "currentPlatform === 'windows'"
    }],
    staticClass: "content",
    attrs: {
      "id": "windows"
    }
  }, [_c('router-link', {
    staticClass: "get-plex",
    attrs: {
      "to": !_vm.$store.state.hasToken ? '/register' : '/dashboard'
    }
  }, [_vm._v(_vm._s(_vm.$t("getPlex")))]), _vm._v(" "), _c('div', {
    staticClass: "gradient-download-btn"
  }, [_c('a', {
    attrs: {
      "href": _vm.windows.downloadInfo.download_link
    },
    on: {
      "click": function($event) {
        return _vm.trackDownload(_vm.windows.platform, _vm.windows.name)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('downloadNow')))])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPlatform === 'mac' || _vm.currentPlatform === 'ubuntu'),
      expression: "currentPlatform === 'mac' || currentPlatform === 'ubuntu'"
    }],
    staticClass: "content"
  }, [_c('router-link', {
    staticClass: "get-plex",
    attrs: {
      "to": !_vm.$store.state.hasToken ? '/register' : '/dashboard'
    }
  }, [_vm._v(_vm._s(_vm.$t("getPlex")))]), _vm._v(" "), _c('div', {
    staticClass: "gradient-download-btn"
  }, [_c('a', {
    attrs: {
      "href": _vm.currentDownloadInfo.downloadInfo.download_link
    },
    on: {
      "click": function($event) {
        return _vm.trackDownload(_vm.currentDownloadInfo.platform, _vm.currentDownloadInfo.name)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('downloadNow')) + "\n      ")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPlatform === 'ios'),
      expression: "currentPlatform === 'ios'"
    }],
    staticClass: "content"
  }, [_c('router-link', {
    staticClass: "get-plex",
    attrs: {
      "to": !_vm.$store.state.hasToken ? '/register' : '/dashboard'
    }
  }, [_vm._v(_vm._s(_vm.$t("getPlex")))]), _vm._v(" "), _c('div', {
    staticClass: "gradient-download-btn"
  }, [_c('a', {
    attrs: {
      "href": _vm.currentDownloadInfo.downloadInfo.download_link,
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.trackDownload(_vm.currentDownloadInfo.platform, _vm.currentDownloadInfo.name)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('downloadNow')) + "\n      ")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPlatform === 'android'),
      expression: "currentPlatform === 'android'"
    }],
    staticClass: "content",
    attrs: {
      "id": "android"
    }
  }, [_c('div', [_c('router-link', {
    staticClass: "get-plex",
    attrs: {
      "to": !_vm.$store.state.hasToken ? '/register' : '/dashboard'
    }
  }, [_vm._v(_vm._s(_vm.$t("getPlex")))]), _vm._v(" "), _c('div', {
    staticClass: "gradient-download-btn"
  }, [_c('a', {
    attrs: {
      "href": _vm.currentDownloadInfo.downloadInfo.download_link
    },
    on: {
      "click": function($event) {
        return _vm.trackDownload(_vm.currentDownloadInfo.platform, _vm.currentDownloadInfo.name)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('downloadNow')))])]), _vm._v(" "), _c('div', {
    staticClass: "qrcode-link"
  }, [_c('img', {
    staticClass: "little-qrcode",
    attrs: {
      "src": "/static/img/downloadNew/ic_qr.svg",
      "alt": "下载PlexVPN安卓客户端"
    }
  }), _vm._v(" "), _c('qr-code', {
    staticClass: "qrcode",
    attrs: {
      "text": _vm.currentDownloadInfo.downloadInfo.download_link,
      "size": 160
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gradient-download-btn"
  }, [_c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.shoplex.plex",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.trackDownload(_vm.currentDownloadInfo.platform, _vm.currentDownloadInfo.name)
      }
    }
  }, [_vm._v("\n        Google Play\n      ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPlatform === 'androidTV'),
      expression: "currentPlatform === 'androidTV'"
    }],
    staticClass: "content"
  }, [_c('router-link', {
    staticClass: "get-plex",
    attrs: {
      "to": !_vm.$store.state.hasToken ? '/register' : '/dashboard'
    }
  }, [_vm._v(_vm._s(_vm.$t("getPlex")))]), _vm._v(" "), _c('div', {
    staticClass: "gradient-download-btn"
  }, [_c('a', {
    attrs: {
      "href": _vm.currentDownloadInfo.downloadInfo.download_link
    },
    on: {
      "click": function($event) {
        return _vm.trackDownload(_vm.currentDownloadInfo.platform, _vm.currentDownloadInfo.name)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('downloadNow')))])])], 1), _vm._v(" "), _c('other-version')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-332eb7e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/download/downloadBtn/DownloadBtn.vue
// module id = 1297
// module chunks = 1